import { createContext } from "react";

import { initialChatInterfaceWidthPx, maxChatInterfaceWidthPx } from "./constants";
import type { AgenticAiChatInterfaceWidthContextType } from "./types";

export const defaultAgenticAiChatInterfaceWidthContext: AgenticAiChatInterfaceWidthContextType = {
  width: initialChatInterfaceWidthPx,
  setWidth: () => {},
  expandToMaxWidth: () => {},
  collapseToMinWidth: () => {},
  isSettingWidth: false,
  onResizeHandleMouseDown: () => {},
  maxPossibleWidth: maxChatInterfaceWidthPx,
};

export const AgenticAiChatInterfaceWidthContext = createContext(defaultAgenticAiChatInterfaceWidthContext);
